import { useSWRMutation } from '@tiger/swr';
import { Button, Form } from 'antd';
import React, { FC } from 'react';
import { $Formutil, withForm } from 'react-antd-formutil';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { BankCardSourceType } from 'components/BankCardSelect';
import { CardButtonWrap } from 'components/Card';
import Debug from 'components/Debug';
import ScrollTop from 'components/ScrollTop';
import Toast from 'components/Toast';
import usePageSafeMode from 'hooks/usePageSafeMode';
import BankCardForm, { BankCardFormItemType } from 'modules/BankCards/components/BankCardForm';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';

export interface AddLocationStates {
    source: BankCardSourceType;
}

interface AddProps {
    $formutil: $Formutil<BankCardFormItemType>;
}

const Add: FC<AddProps> = ({ $formutil }) => {
    usePageSafeMode();

    const { $invalid, $batchState, $getFirstError, $params } = $formutil;
    const navigate = useNavigate();
    const location = useLocation();
    const locationStates = location.state as AddLocationStates | null;
    const { source } = locationStates || {};
    const { trigger } = useSWRMutation('bankcard.add', (params: BankCardFormItemType) =>
        http.post(
            API.TRADE.bankcards.addBankCard(),
            {
                ...params,
                bankAccountType: 1, // 美国用户的银行账号基本都是单币种类型
                supportCurrencies: 'USD', // 单币种传入美元
                source,
                accountId: security.currentAccountId,
                customerId: security.currentCustomerId
            },
            {
                params: {
                    customer_id: security.currentCustomerId,
                    account_id: security.currentAccountId
                }
            }
        )
    );

    const handleSubmit = async () => {
        if ($invalid) {
            $batchState({
                $dirty: true,
                $touched: true
            });

            Toast.show($getFirstError());
        } else {
            Toast.loading(true);

            try {
                await trigger($params);

                navigate(-1);
            } catch (err) {
                Toast.show(err);
            }

            Toast.loading(false);
        }
    };

    if (!source) {
        return <Navigate to="/profile" replace />;
    }

    return (
        <div className="add-bank-card-root">
            <ScrollTop />
            <h3 className="main-title">{__('Add bank account')}</h3>
            <Form layout="vertical" onFinish={handleSubmit}>
                <BankCardForm source={locationStates?.source} />
                <CardButtonWrap className="btn-box">
                    <Button
                        size="large"
                        className="btn-important"
                        onClick={() => {
                            navigate(-1);
                        }}>
                        {__('Cancel')}
                    </Button>
                    <Button size="large" block type="primary" className="btn-important" htmlType="submit">
                        {__('Save')}
                    </Button>
                </CardButtonWrap>
                <Debug data={$params} />
            </Form>
        </div>
    );
};

export default withForm(Add);
